import RootOutlet from "@components/RootOutlet"
import ErrorPage from "@pages/ErrorPage"
import { Navigate, Outlet } from "react-router-dom"
import accountRoutes from "./account/accountRoutes"
import checkoutRoutes from "./checkout/checkoutRoutes"
import helpCenterRoutes from "./helpCenter/helpCenterRoutes"
import onboardingRoutes from "./onboarding/onboardingRoutes"
import signUpRoutes from "./signUp/signUpRoutes"

const routes = [
  {
    element: <RootOutlet />,
    errorElement: <ErrorPage />,
    path: "/",
    children: [
      {
        element: <Navigate to="onboarding" replace />,
        index: true,
      },
      {
        element: <Outlet />,
        path: "account",
        children: accountRoutes,
      },
      {
        element: <Outlet />,
        path: "checkout",
        children: checkoutRoutes,
      },
      {
        path: "drivers", // NOTE: Needed, because our Facebook ads point here.
        element: (
          <Navigate to={`/onboarding/age${window.location.search}`} replace />
        ),
      },
      {
        path: "forgot-password", // NOTE: Needed, because the apps are pointing here.
        element: <Navigate to="/account/forgot-password" replace />,
      },
      {
        path: "help", // NOTE: Needed, because the apps are pointing here.
        element: <Navigate to="/help-center" replace />,
      },
      {
        element: <Outlet />,
        path: "help-center",
        children: helpCenterRoutes,
      },
      {
        path: "login", // NOTE: Needed, because the apps are pointing here.
        element: <Navigate to="/account/sign-in" replace />,
      },
      {
        element: <Outlet />,
        path: "onboarding",
        children: onboardingRoutes,
      },
      {
        element: <Outlet />,
        path: "sign-up",
        children: signUpRoutes,
      },
      {
        path: "*",
        element: <Navigate to="/onboarding" replace />,
      },
    ],
  },
]

export default routes
